<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    d="M30 24C30 27.3137 27.3137 30 24 30C20.6863 30 18 27.3137 18 24C18 20.6863 20.6863 18 24 18C27.3137 18 30 20.6863 30 24Z"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M4.9165 23.9999C7.46505 15.8858 15.0456 10 24.0009 10C32.9562 10 40.5368 15.8858 43.0853 24.0001C40.5367 32.1142 32.9562 38 24.0009 38C15.0456 38 7.46501 32.1142 4.9165 23.9999Z"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
